"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TYPE = exports.DEFAULT_STANDARDCONFIG = exports.DEFAULT_PRIMECONFIG = exports.DEFAULT_IMAGE = exports.ADS_PLACEHOLDER_TYPE = void 0;
/* eslint-disable max-len */
var ADS_PLACEHOLDER_TYPE = {
  PRIME: 'prime',
  STANDARD: 'standard'
};
exports.ADS_PLACEHOLDER_TYPE = ADS_PLACEHOLDER_TYPE;
var DEFAULT_TYPE = ADS_PLACEHOLDER_TYPE.PRIME;
exports.DEFAULT_TYPE = DEFAULT_TYPE;
var DEFAULT_IMAGE = {
  PRIME: {
    // 728x90
    DESKTOP: 'https://images.contentstack.io/v3/assets/blt3b916845fcb268b5/blta2543e8d4b2abdfc/60e57d9e92aa422edd5e4371/ads-default-728x90.png',
    // 300x250
    MOBILE: 'https://images.contentstack.io/v3/assets/blt3b916845fcb268b5/bltcb13aec5af4c6a98/60e57da0ccb5203c30a2a09c/ads-default-300x250.png'
  },
  STANDARD: {
    // 570x180
    DESKTOP: 'https://images.contentstack.io/v3/assets/blt3b916845fcb268b5/blt1d145f0471d4cb7c/60e57d9fe7a80f3c2a86a084/ads-default-570x180.png',
    // 360x180
    MOBILE: 'https://images.contentstack.io/v3/assets/blt3b916845fcb268b5/bltc62c225ef95390a7/60e57d9ee743d53d6a654f45/ads-default-360x280.png'
  }
};
exports.DEFAULT_IMAGE = DEFAULT_IMAGE;
var DEFAULT_PRIMECONFIG = {
  image: {
    desktopImageUrl: DEFAULT_IMAGE.PRIME.DESKTOP,
    mobileImageUrl: DEFAULT_IMAGE.PRIME.MOBILE,
    alt: 'AirAsia Ads'
  },
  dimensions: {
    desktop: {
      width: '728px',
      height: '90px'
    },
    mobile: {
      width: '300px',
      height: '250px'
    }
  }
};
exports.DEFAULT_PRIMECONFIG = DEFAULT_PRIMECONFIG;
var DEFAULT_STANDARDCONFIG = {
  image: {
    desktopImageUrl: [DEFAULT_IMAGE.STANDARD.DESKTOP, DEFAULT_IMAGE.STANDARD.DESKTOP],
    mobileImageUrl: [DEFAULT_IMAGE.STANDARD.MOBILE, DEFAULT_IMAGE.STANDARD.MOBILE],
    space: 'standard',
    alt: ['AirAsia Ads', 'AirAsia Ads']
  },
  dimensions: {
    desktop: {
      width: '570px',
      height: '180px'
    },
    mobile: {
      width: '360px',
      height: '180px'
    }
  }
};
exports.DEFAULT_STANDARDCONFIG = DEFAULT_STANDARDCONFIG;